jQuery(function ($) {
  if (window.matchMedia("(max-width: 1023px)").matches) {
    $(".b-games-calendar-slider").slick({
      rtl: true,
      infinite: false,
      slidesToShow: 1.05,
      dots: true,
      arrows: false,
    });

    $(".b-game-reviews-slider").slick({
      rtl: true,
      infinite: false,
      slidesToShow: 3.4,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2.5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.11,
          },
        },
      ],
    });
  }

  $(".b-featured").slick({
    rtl: true,
    slidesToShow: 1,
    arrows: true,
    prevArrow: $("#custom-prev"),
    nextArrow: $("#custom-next"),
  });
});
